import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs } from "swiper/modules";
import "swiper/css";
import "swiper/css/thumbs";
import styles from "./ImageGallery.module.scss";
import ArrowLeft from "../../../assets/svgs/arrows/ArrowLeft";
import ArrowRight from "../../../assets/svgs/arrows/ArrowRight";

interface ImageType {
  id: number;
  image: string;
}

interface ImageGalleryProps {
  images: ImageType[];
  alt?: string;
  className?: string;
}

const ImageGallery: React.FC<ImageGalleryProps> = ({
  images,
  alt = "Product image",
  className = "",
}) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const mainSwiperRef = useRef<any>(null);

  if (!images || images.length === 0) return null;

  const handlePrev = () => mainSwiperRef.current?.slidePrev();
  const handleNext = () => mainSwiperRef.current?.slideNext();

  const handleThumbClick = (index: number) => {
    setActiveIndex(index);
    mainSwiperRef.current?.slideTo(index);
  };

  return (
    <div className={`${styles.gallery} ${className}`}>
      <div className={styles.sliderWrapper}>
        <button className={styles.arrowLeft} onClick={handlePrev}>
          <ArrowLeft />
        </button>

        <Swiper
          modules={[Thumbs]}
          onSwiper={(swiper: any) => (mainSwiperRef.current = swiper)}
          onSlideChange={(swiper: any) => setActiveIndex(swiper.activeIndex)}
          spaceBetween={10}
          className={styles.mainSlider}
        >
          {images.map((img, index) => (
            <SwiperSlide key={img.id}>
              <div
                className={`${styles.mainSlide} ${
                  activeIndex === index ? styles.activeSlide : ""
                }`}
              >
                <img src={img.image} alt={alt} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <button className={styles.arrowRight} onClick={handleNext}>
          <ArrowRight />
        </button>
      </div>

      <Swiper
        modules={[Thumbs]}
        spaceBetween={16}
        slidesPerView={5}
        className={styles.thumbSlider}
        breakpoints={{
          993: { slidesPerView: 4 },
          576: { slidesPerView: 8 },
          0: { slidesPerView: 4 },
        }}
      >
        {images.map((img, index) => (
          <SwiperSlide key={img.id}>
            <div
              className={`${styles.thumb} ${
                activeIndex === index ? styles.thumbActive : ""
              }`}
              onClick={() => handleThumbClick(index)}
            >
              <img src={img.image} alt="thumbnail" />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ImageGallery;
